import React from 'react';

export default function SizeModal({ item, currency, onSelectSize, onClose }) {
  if (!item) return null;

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h3 style={{ margin: '0 0 1rem 0' }}>Select Size for {item.name}</h3>
        {item.sizes.map((s) => (
          <button
            key={s.name}
            onClick={() => onSelectSize(item, s, s.price)}
            style={sizeOptionBtn}
          >
            <span>{s.name}</span>
            <span>{currency} {s.price}</span>
          </button>
        ))}
        <button onClick={onClose} style={cancelBtn}>Close</button>
      </div>
    </div>
  );
}

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 200 };
const modalContentStyle = { background: '#FFF', width: '100%', maxWidth: '480px', borderTopLeftRadius: '16px', borderTopRightRadius: '16px', padding: '1.25rem', boxSizing: 'border-box' };
const sizeOptionBtn = { width: '100%', display: 'flex', justifyContent: 'space-between', padding: '0.75rem 1rem', marginBottom: '0.5rem', border: '1px solid #E5E7EB', borderRadius: '8px', background: '#F9FAFB', cursor: 'pointer' };
const cancelBtn = { width: '100%', padding: '0.6rem', border: 'none', background: '#E5E7EB', borderRadius: '8px', color: '#374151', marginTop: '0.5rem', cursor: 'pointer' };